export const agenticIaProgramData = {
	niveau1: {
		pageTitle: 'Fondamentaux Agentic AI',
		programOption: 'Agentic AI - Niveau 1',
		tabs: [
			{
				id: 'tab-1',
				label: 'Objectif',
				title: 'Devenir rapidement opérationnel en intelligence artificielle ',
				subtitle:
					'Le Niveau 1 de la formation Agentic IA constitue une porte d’entrée idéale pour toute personne souhaitant apprendre l’intelligence artificielle sans expérience préalable. Ce niveau a pour objectif de développer une employabilité rapide, en permettant aux apprenants de comprendre les bases de l’IA, de l’automatisation et du développement informatique.  ',
				items: [],
			},

			{
				id: 'tab-3',
				label: 'Programme ',
				title: 'Programme ',
				items: [
					{
						id: 'module-1',
						title:
							'Module 1 : Culture numérique & transformation digitale (30h)',
						content: `
			<p><strong>Sous-module 1 : Environnement numérique moderne</strong></p>
			<ul>
				<li>Données, gouvernance, cybersécurité : Comprendre comment les données sont gérées et sécurisées.</li>
				<li>Cloud computing : Découvrir les principaux modèles cloud et leurs usages.</li>
				<li>API & intégrations : Voir comment les API connectent les outils et automatisent les échanges.</li>
			</ul>

			<p><strong>Sous-module 2 : Transformation digitale dans les organisations</strong></p>
			<ul>
				<li>Automatisation : Comprendre comment le digital optimise les tâches et workflows.</li>
				<li>RPA vs Agents IA : Distinguer automatisation classique et automatisation intelligente.</li>
				<li>Impacts métiers : Identifier les transformations dans RH, finance, support, industrie, commerce.</li>
			</ul>

			<p><strong>Sous-module 3 : AI Literacy & Usage Responsable de l’IA</strong></p>
			<ul>
				<li>Fonctionnement des modèles d’IA (logique probabiliste, données d’entraînement)</li>
				<li>Limites des systèmes : hallucinations, biais algorithmiques, erreurs</li>
				<li>Risques en entreprise : mauvaise décision, automatisation non maîtrisée</li>
				<li>Éthique & gouvernance : confidentialité, RGPD, propriété intellectuelle</li>
				<li>Bonnes pratiques : validation des outputs, rôle de l’humain, usage responsable</li>
			</ul>

			<p><strong>Sous-module 4 : Introduction aux agents IA</strong></p>
			<ul>
				<li>Types d’agents : Découvrir les agents no-code, low-code et autonomes.</li>
				<li>Architecture : Comprendre les éléments essentiels d’un agent IA.</li>
				<li>Rôles & limites : Saisir ce qu’un agent peut ou ne peut pas faire.</li>
			</ul>

			<p><strong>Sous-module 5 : Études de cas & retours d’expérience</strong></p>
			<ul>
				<li>Analyse d’agents existants : Examiner des exemples concrets.</li>
				<li>Implémentations réelles : Comprendre comment les entreprises les utilisent.</li>
				<li>Discussions : Partager bonnes pratiques et enseignements.</li>
			</ul>
			`,
					},
					{
						id: 'module-2',
						title:
							'Module 2 : Raisonnement informatique & logique algorithmique (30h)',
						content: `
			<p><strong>Sous-module 1 : Bases du raisonnement logique</strong></p>
			<ul>
				<li>Pensée algorithmique : Structurer un raisonnement étape par étape.</li>
				<li>Logique conditionnelle : Comprendre les décisions simples.</li>
				<li>Décomposition : Simplifier un problème complexe.</li>
			</ul>

			<p><strong>Sous-module 2 : Représentation d’algorithmes</strong></p>
			<ul>
				<li>Flowcharts : Visualiser un processus.</li>
				<li>Pseudo-code : Décrire un algorithme avant de coder.</li>
				<li>Modélisation : Transformer un besoin en logique claire.</li>
			</ul>

			<p><strong>Sous-module 3 : Exercices pratiques</strong></p>
			<ul>
				<li>Scénarios métiers : Appliquer les logiques à des cas simples.</li>
				<li>Mini-problèmes : S’entraîner sur des exercices progressifs.</li>
				<li>Ateliers visuels : Manipuler des blocs logiques.</li>
			</ul>
			`,
					},
					{
						id: 'module-3',
						title: 'Module 3 : Programmation Python (débutant – PCEP) (60h)',
						content: `
			<p><strong>Sous-module 1 : Fondamentaux de Python</strong></p>
			<ul>
				<li>Variables & types : Manipuler les données de base.</li>
				<li>Listes & dictionnaires : Utiliser les structures essentielles.</li>
				<li>Conditions & boucles : Contrôler le déroulement du code.</li>
			</ul>

			<p><strong>Sous-module 2 : Fonctions & modules</strong></p>
			<ul>
				<li>Fonctions : Organiser et réutiliser son code.</li>
				<li>Modules standards : Découvrir les outils intégrés.</li>
				<li>Bonnes pratiques : Écrire proprement et clairement.</li>
			</ul>

			<p><strong>Sous-module 3 : Fichiers & APIs</strong></p>
			<ul>
				<li>Fichiers CSV/TXT : Lire et écrire des données simples.</li>
				<li>Appels API : Interagir avec un service externe.</li>
				<li>SQLite : Manipuler une petite base locale.</li>
			</ul>
			`,
					},
				],
			},
			{
				id: 'tab-2',
				label: 'Format & rythme',
				title: 'Format & rythme',
				subtitle: `
				<ul>
				<li>Durée : 120 heures - 15 semaines </li>
				<li>Format  : Hybride</li>
				<li>Rythme : 15 heures / semaine</li>
				</ul>
				`,
				items: [],
			},

			//{
			//	id: 'tab-4',
			//	label: 'Résultats attendus',
			//	title: 'Résultats attendus',
			//	items: [
			//		{
			//			id: 'skills-block',
			//			title: 'Compétences développées',
			//			content: `
			//<ul>
			//	<li>Culture numérique & intelligence artificielle</li>
			//	<li>Logique algorithmique & raisonnement informatique</li>
			//	<li>Programmation Python (niveau débutant – PCEP)</li>
			//	<li>Introduction aux agents IA</li>
			//	<li>Automatisation simple no-code / low-code</li>
			//</ul>
			//`,
			//		},
			//	],
			//},
		],
	},

	niveau2: {
		pageTitle: 'Agentic AI - Niveau 2',
		programOption: 'Agentic AI - Niveau 2',
		tabs: [
			{
				id: 'tab-1',
				label: 'Objectif',
				title: 'Advanced Agentic IA & AI Agent concepteur',
				subtitle:
					'Le Niveau 2 représente une montée en compétence majeure. Il transforme les apprenants en AI Agent Designers, capables de concevoir, développer et déployer des agents IA complets pour les entreprises.  ',
				items: [],
			},
			{
				id: 'tab-2',
				label: 'Format & rythme',
				title: 'Format & rythme',
				subtitle: `
				<ul>
				<li>Durée : 225 heures - 15 semaines  </li>
				<li>Format  : Hybride</li>
				<li>Rythme : 15 heures / semaine</li>
				</ul>
				`,
				items: [],
			},
			{
				id: 'tab-3',
				label: 'Programme ',
				title: 'Programme ',
				items: [
					{
						id: 'module-4',
						title: 'Module 4 : IA générative & Prompt Engineering (30h)',
						content: `
		<p><strong>Sous-module 1 : Modèles de langage</strong></p>
		<ul>
			<li>Fonctionnement : Comprendre comment un LLM génère du texte.</li>
			<li>Capacités & limites : Savoir ce qu’un LLM peut faire.</li>
			<li>Usages : Découvrir les applications en entreprise.</li>
		</ul>

		<p><strong>Sous-module 2 : Techniques de prompt</strong></p>
		<ul>
			<li>Types de prompts : Choisir la bonne structure.</li>
			<li>Clarté & contexte : Donner des instructions efficaces.</li>
			<li>Itérations : Améliorer progressivement un prompt.</li>
		</ul>

		<p><strong>Sous-module 3 : Applications pratiques</strong></p>
		<ul>
			<li>Chaînes de prompts : Créer des mini-workflows.</li>
			<li>Assistants IA : Construire un assistant simple no-code.</li>
			<li>Cas métiers : Adapter les prompts à différents services.</li>
		</ul>
		`,
					},
					{
						id: 'module-5',
						title: 'Module 5 : Création d’agents IA no-code & low-code (75h)',
						content: `
		<p><strong>Sous-module 1 : Outils no-code/low-code pour agents IA</strong></p>
		<ul>
			<li>Flowise : création de workflows IA visuels</li>
			<li>Make / Zapier : automatisation entre outils métiers</li>
			<li>Voiceflow / Botpress : agents conversationnels</li>
			<li>Cas d’usage : support client, génération de leads, automatisation interne</li>
		</ul>

		<p><strong>Sous-module 2 : Conception d’agents</strong></p>
		<ul>
			<li>Structure d’un agent IA (input → traitement → action)</li>
			<li>Intégration APIs & webhooks</li>
			<li>Connexion à des sources de données (documents, CRM, Google Sheets…)</li>
			<li>Création de workflows multi-étapes</li>
			<li>Adaptation à des cas réels (RH, sales, support…)</li>
		</ul>

		<p><strong>Sous-module 3 : Déploiement, tests & optimisation</strong></p>
		<ul>
			<li>Mise en production (web, API, chatbot, automation)</li>
			<li>Tests utilisateurs & validation</li>
			<li>Gestion des erreurs et fallback</li>
			<li>Optimisation des performances et de l’expérience utilisateur</li>
			<li>Amélioration continue basée sur feedback</li>
		</ul>
		`,
					},
					{
						id: 'module-6',
						title:
							'Module 6 : Développement d’agents IA avec Python & LangChain (60h)',
						content: `
		<p><strong>Sous-module 1 : Intégration des modèles IA & APIs</strong></p>
		<ul>
			<li>Utilisation des APIs (OpenAI, Mistral, HuggingFace)</li>
			<li>Gestion des clés API et bonnes pratiques de sécurité</li>
			<li>Paramétrage des modèles (température, tokens, etc.)</li>
			<li>Tests et évaluation des réponses générées</li>
		</ul>

		<p><strong>Sous-module 2 : Construction de workflows avec LangChain</strong></p>
		<ul>
			<li>Création de chains (enchaînement de tâches)</li>
			<li>Intégration de tools (APIs, calculs, recherche web…)</li>
			<li>Gestion de la mémoire (contexte conversationnel)</li>
			<li>Structuration d’un workflow d’agent IA</li>
		</ul>

		<p><strong>Sous-module 3 : Développement d’agents IA avancés</strong></p>
		<ul>
			<li>Introduction aux architectures d’agents (react, planner, etc.)</li>
			<li>Embeddings & vector stores (RAG – Retrieval Augmented Generation)</li>
			<li>Connexion à des bases de connaissances</li>
			<li>Gestion des erreurs et optimisation des performances</li>
			<li>Mini-projets : création d’un agent IA métier (support, RH, sales…)</li>
		</ul>
		`,
					},
					{
						id: 'module-7',
						title:
							'Module 7 : Cadrage de projets IA & conception de solutions intelligentes (60h)',
						content: `
		<p><strong>Sous-module 1 : Analyse du besoin métier</strong></p>
		<ul>
			<li>Identification des pain points</li>
			<li>Analyse des processus métier</li>
			<li>Priorisation des cas d’usage IA</li>
			<li>Introduction au ROI</li>
		</ul>

		<p><strong>Sous-module 2 : Cadrage & architecture</strong></p>
		<ul>
			<li>Définition des objectifs</li>
			<li>Identification des données</li>
			<li>Choix des solutions</li>
			<li>Architecture d’un agent IA</li>
			<li>Rédaction d’un cahier des charges</li>
		</ul>

		<p><strong>Sous-module 3 : Prototypage & gestion agile</strong></p>
		<ul>
			<li>Design thinking</li>
			<li>Construction de MVP</li>
			<li>Méthodes agiles</li>
			<li>Organisation projet</li>
			<li>Tests & amélioration continue</li>
		</ul>
		`,
					},
					{
						id: 'module-final',
						title: 'Projet final professionnel',
						content: `
		<p><strong>Partie 1 : Conception</strong></p>
		<ul>
			<li>Choisir un cas réel</li>
			<li>Analyse fonctionnelle</li>
			<li>Planning</li>
		</ul>

		<p><strong>Partie 2 : Développement</strong></p>
		<ul>
			<li>No-code → Low-code → Python</li>
			<li>Intégrations APIs</li>
			<li>Tests</li>
		</ul>

		<p><strong>Partie 3 : Finalisation</strong></p>
		<ul>
			<li>Documentation</li>
			<li>Déploiement</li>
			<li>Soutenance</li>
		</ul>
		`,
					},
				],
			},
			//{
			//	id: 'tab-4',
			//	label: 'Résultats attendus',
			//	title: 'Résultats attendus',
			//	items: [
			//		{
			//			id: 'skills-block',
			//			title: 'Compétences développées',
			//			content: `
			//<ul>
			//	<li>IA générative & prompt engineering, </li>
			//	<li>Agents IA no-code & low-code, </li>
			//	<li>design thinking & cadrage de projets IA</li>
			//	<li>Python avancé & LangChain, intégration APIs et données</li>
			//</ul>
			//`,
			//		},
			//	],
			//},
		],
	},
};
